import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { onActivated, onMounted, reactive, toRefs } from "vue";
import apis from "@/api";
import { useRouter } from 'vue-router';
import download from "@/utils/download";
import { srcType } from "@/utils/srcType";
export default {
  props: {
    id: String
  },
  setup(props, ctx) {
    const {
      singleDownload
    } = download();
    let data = reactive({
      bodyStyle: {
        'background-color': '#E9EEF3',
        'padding': '5px 10px 5px 10px'
      },
      posBizInfo: {
        areaList: [],
        assetBaseInfo: {},
        assetsPosNames: [],
        positionBizDownList: [],
        unDownAreaNameList: []
      },
      srcType: srcType,
      isDownloading: false
    });
    const loadData = id => {
      apis.queryOffLPosBizById(id).then(res => {
        // console.log(res,"queryOffLPosBizById")
        if (res.success) {
          if (res.data.areaList.length > 0) {
            let areaListTmp = [];
            res.data.areaList.forEach(item => {
              areaListTmp.push(item.areaName);
            });
            res.data.areaList = areaListTmp;
          }
          data.posBizInfo = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const route = useRouter();
    onActivated(() => {
      let id = route.currentRoute.value.query.id;
      if (id) {
        loadData(id);
      }
    });
    const router = useRouter();
    const putAsset = () => {
      router.push(`/operation/offline/off-position-biz-put?id=${data.posBizInfo.id}&opType=edit`);
    };
    const downAsset = () => {
      console.log("----------");
      data.isDownloading = true;
      singleDownload(data.posBizInfo.assetBaseInfo.id, data.posBizInfo.assetBaseInfo.assetsName).then(() => {
        data.isDownloading = false;
      }).finally(() => {
        data.isDownloading = false;
      });
    };
    const sendRemindSms = () => {
      if (data.posBizInfo.unDownAreaNameList.length > 0) {
        apis.sendRemindSms(data.posBizInfo.id).then(res => {
          if (res.success) {
            ElMessage.success("发送成功");
          }
        });
      } else {
        ElMessage.warning("所有投放渠道都已经下载！");
      }
    };
    return {
      ...toRefs(data),
      loadData,
      putAsset,
      downAsset,
      sendRemindSms,
      singleDownload
    };
  }
};